import { CoinID } from '@starsoft/common/enums';
import { Nullable } from '@starsoft/common/interfaces';
import { UserPaymentDetailsTypeId } from '../enums/user-payment-details/type/id';
import { CoinIDType } from '../enums/coinId';

export namespace UserPaymentDetailsNamespace {
  export function getUserPaymentDetailsTypeIdByCoinId(
    coinId: CoinIDType,
  ): Nullable<string> {
    switch (coinId?.toString()) {
      case CoinID.BRL?.toString():
        return UserPaymentDetailsTypeId.Pix?.toString();
      case CoinID.INR?.toString():
        return UserPaymentDetailsTypeId.Imps?.toString();
      case CoinID.ARS?.toString():
        return UserPaymentDetailsTypeId.ArgentineBankAccount?.toString();
      case CoinID.MXN?.toString():
        return UserPaymentDetailsTypeId.MexicanBankAccount?.toString();
      case CoinID.ZAR?.toString():
        return UserPaymentDetailsTypeId.SouthAfricaBankAccount?.toString();
      case CoinID.SGD?.toString():
        return UserPaymentDetailsTypeId.SingaporeBankAccount?.toString();
      case CoinID.IDR?.toString():
        return UserPaymentDetailsTypeId.Qris?.toString();
      case CoinID.NGN?.toString():
        return UserPaymentDetailsTypeId.NigerianBankAccount?.toString();
      default:
        return null;
    }
  }
}
